import { SwitchToggle } from '@teetsh/app/src/components/Form/SwitchToggle';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';
import { useEarlyStageFeatures } from '@teetsh/app/src/queries/user/useEarlyStageFeatures';
import { UserLocale } from '@teetsh/app/src/types/user';
import React from 'react';
import { useTranslation } from 'react-i18next';

function extractFeactureDescription(
  description: string,
  country: UserLocale,
  defaultDescription: string,
) {
  try {
    const parsedDescription = JSON.parse(description);
    return parsedDescription[country] || defaultDescription;
  } catch (e) {
    return defaultDescription;
  }
}

export function Features() {
  const { isFeatureActive, features, updateEarlyAccessFeatureEnrollment } =
    useEarlyStageFeatures();
  const { t } = useTranslation(['userSettings', 'common']);

  if (features.length === 0) {
    return null;
  }

  return (
    <TwoColumnsCardSidebar.Section
      title={t('userSettings:account.laboratoryTeetsh')}
    >
      <div tw="mb-8">
        <hr tw="mb-3" />
        <div tw="space-y-2">
          {features.map(feature => (
            <SwitchToggle
              key={feature.name}
              size="lg"
              label={extractFeactureDescription(
                feature.description,
                t('common:locale.long'),
                t('userSettings:account.activateDefaultFeatureDescription', {
                  featureName: feature.name,
                }),
              )}
              onChange={v =>
                updateEarlyAccessFeatureEnrollment(feature.flagKey!, v)
              }
              checked={isFeatureActive(feature.flagKey!)}
            />
          ))}
        </div>
      </div>
    </TwoColumnsCardSidebar.Section>
  );
}
